export const flexParentCenter = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};
